import { render, staticRenderFns } from "./DefectReportIndex.vue?vue&type=template&id=30a1ac74&scoped=true&"
import script from "./DefectReportIndex.vue?vue&type=script&lang=js&"
export * from "./DefectReportIndex.vue?vue&type=script&lang=js&"
import style0 from "./DefectReportIndex.vue?vue&type=style&index=0&id=30a1ac74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a1ac74",
  null
  
)

export default component.exports